import {
  useManuscriptImportStore,
} from '@/stores/manuscripts';
import * as manuscriptTypes from '@/lib/constants/manuscripts/store';

export function createRouteHandler(router, pinia) {
  const onBeforeEach = (to, from, next) => {
    const manuscriptImportStore = useManuscriptImportStore(pinia);

    let navSuccess = true;

    if (from.name === 'manuscript-import' && to.name !== from.name) {
      if (manuscriptImportStore.hasImportItems) {
        next(false);

        navSuccess = false;

        manuscriptImportStore[manuscriptTypes.SET_CONFIRM_NAVIGATE_DIALOG]({
          onConfirm: () => {
            router.push(to);
          },
        });
      }
    }

    return navSuccess;
  };

  return {
    onBeforeEach,
  };
}

export default {
  createRouteHandler,
};
